import { IconButton } from 'component/Button/IconButton'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'
import css from './BasicHeader.module.scss'

export const BasicHeader = observer(() => {
  const onMin = useLatestCallback(() => {
    store.state = 'none'
  })

  return <Space className={css.header}>
    <IconButton size={64} link action={onMin}>
      <Icon name="close" size={32} />
    </IconButton>
  </Space>
})
